import { __extends } from "tslib";
import React from 'react';
import ViewModelBase from './ViewModelBase';
var ViewComponentBase = /** @class */ (function (_super) {
    __extends(ViewComponentBase, _super);
    /**
     * Creates a view component.
     * @param props Component props.
     * @param viewModel Instance of view model, or view model type, or callback which returns a view model. Taskrunner will be set only if passing in VM type.
     */
    function ViewComponentBase(props, viewModel) {
        var _this = _super.call(this, props) || this;
        _this.viewModel = ViewModelBase.create(viewModel, props.taskRunner);
        return _this;
    }
    ViewComponentBase.prototype.componentDidMount = function () {
        this.viewModel.initialise();
    };
    ViewComponentBase.prototype.componentWillUnmount = function () {
        this.viewModel.dispose();
    };
    return ViewComponentBase;
}(React.Component));
export default ViewComponentBase;
